import React from 'react';
import Icon from '@/components/atoms/UI/Icon/Icon';
import styled from 'styled-components';
import { basicColor, transition } from '@/styles/template';

interface Props {
	onClick?: any
	disabled?: boolean
}

const DeleteBtn = styled.button`
	cursor: pointer;
  
	&:hover .colorFill {
		transition: ${transition.fastEnd};
		fill: ${basicColor.red};
	}
`

const DeleteButton: React.FC<Props> = ({ onClick, disabled }) => {
	return (
		<DeleteBtn  onClick={onClick} disabled={disabled}>
			<Icon name={'Delete'} />
		</DeleteBtn>

	)
}

export default DeleteButton